<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Lista de precio
			</template>

			<template v-slot:subtitle v-if="pricelist">
				{{ pricelist.name }}
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							v-on="on"
							elevation="5"
							v-bind="attrs"
							color="default"
							:loading="ui.exporting"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="pricelistEdit()" v-if="!ui.edit">
							<v-list-item-title>
								Editar
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="exportToCSV()">
							<v-list-item-title>
								Exportar
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="importFromCSV()">
							<v-list-item-title>
								Sincronización
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="customerAttach()">
							<v-list-item-title>
								Vincular cliente
							</v-list-item-title>
						</v-list-item>

						<!-- <v-list-item @click="articleAttach()">
							<v-list-item-title>
								Vincular artículo
							</v-list-item-title>
						</v-list-item> -->

						<!-- <v-list-item
							@click="ui.dialog = true"
							v-if="selected.length && ui.tab == 0"
						>
							<v-list-item-title>
								Edición multiple
							</v-list-item-title>
						</v-list-item> -->
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="10">
					<v-card
						outlined
						:loading="ui.loading"
						:disabled="ui.loading"
					>
						<v-card-text class="pt-1">
							<template v-if="pricelist">
								<v-row>
									<v-col cols="12">
										<v-tabs v-model="ui.tab">
											<v-tab>
												<v-icon left>
													mdi-card-text-outline
												</v-icon>
												General
											</v-tab>

											<v-tab>
												<v-icon left>
													mdi-cube-outline
												</v-icon>

												Artículos
												<template>
													<span
														v-if="
															pricelist.articles
														"
													>
														{{
															`(${pricelist.articles.length})`
														}}
													</span>
												</template>
											</v-tab>

											<v-tab>
												<v-icon left>
													mdi-account-multiple-outline
												</v-icon>
												Clientes
												<template>
													<span
														v-if="
															pricelist.customers
														"
													>
														{{
															`(${pricelist.customers.length})`
														}}
													</span>
												</template>
											</v-tab>

											<!-- General -->
											<v-tab-item>
												<template v-if="ui.edit">
													<v-form
														ref="formPriceList"
														lazy-validation
														@submit.prevent="
															pricelistUpdate()
														"
														v-model="
															ui.forms.price_list
																.valid
														"
													>
														<v-row class="pt-2">
															<v-col cols="12">
																<v-text-field
																	dense
																	outlined
																	clearable
																	hide-details
																	:rules="[
																		v.required,
																	]"
																	label="Nombre"
																	v-model="
																		layout.name
																	"
																	clearable
																></v-text-field>
															</v-col>

															<v-col
																cols="12"
																:class="[
																	'd-flex justify-end',
																	{
																		'flex-column':
																			$vuetify
																				.breakpoint
																				.smAndDown,
																	},
																]"
															>
																<v-btn
																	:block="
																		$vuetify
																			.breakpoint
																			.smAndDown
																	"
																	text
																	color="primary"
																	@click="
																		pricelistEditCancel()
																	"
																>
																	cancelar
																</v-btn>

																<v-btn
																	:block="
																		$vuetify
																			.breakpoint
																			.smAndDown
																	"
																	color="primary"
																	:class="[
																		$vuetify
																			.breakpoint
																			.smAndDown
																			? 'mt-2'
																			: 'ml-2',
																	]"
																	@click="
																		pricelistUpdate()
																	"
																	:disabled="
																		!ui
																			.forms
																			.price_list
																			.valid
																	"
																>
																	enviar
																</v-btn>
															</v-col>
														</v-row>
													</v-form>
												</template>

												<template v-else>
													<v-row class="pt-2">
														<v-col
															cols="12"
															md="4"
															class="d-flex flex-column"
														>
															<strong>
																Nombre:
															</strong>
															{{ pricelist.name }}
														</v-col>

														<v-col
															cols="12"
															md="4"
															class="d-flex flex-column"
														>
															<strong>
																Creado:
															</strong>
															{{
																pricelist.created_at_new
															}}
														</v-col>

														<v-col
															cols="12"
															md="4"
															class="d-flex flex-column"
														>
															<strong>
																Modificado:
															</strong>
															{{
																pricelist.updated_at_new
															}}
														</v-col>
													</v-row>
												</template>
											</v-tab-item>

											<v-tab-item>
												<v-row class="pt-2">
													<v-col
														cols="12"
														md="6"
														class="pb-0 mb-0"
													>
														<v-text-field
															dense
															outlined
															hide-details
															label="Críterio de busqueda"
															v-model="
																filters.criterion
															"
															clearable
														></v-text-field>
													</v-col>

													<v-col
														cols="6"
														md="3"
														class="pb-0"
													>
														<v-overflow-btn
															dense
															outlined
															editable
															clearable
															hide-details
															label="Familia"
															autocomplete="off"
															:items="Categories"
															v-model="
																filters.category_id
															"
														>
														</v-overflow-btn>
													</v-col>

													<v-col
														cols="6"
														md="3"
														class="pb-0"
													>
														<v-overflow-btn
															dense
															outlined
															editable
															clearable
															hide-details
															autocomplete="off"
															label="Producto"
															:items="Products"
															v-model="
																filters.product_id
															"
														>
														</v-overflow-btn>
													</v-col>

													<v-col
														cols="12"
														class="pb-0 mb-0"
													>
														<v-data-table
															:headers="
																headers.articles
															"
															:items="Articles"
															:search="
																filters.criterion
															"
															v-model="selected"
															item-key="id"
														>
															<!-- Slot Article -->
															<template
																v-slot:item.code="{
																	item,
																}"
															>
																<router-link
																	:to="{
																		name:
																			'ArticleIndex',
																		query: {
																			criterium:
																				item.code,
																		},
																	}"
																>
																	{{
																		item.code
																	}}
																</router-link>
															</template>

															<!-- Slot base_price -->
															<template
																v-slot:item.base_price="{
																	item,
																}"
															>
																{{
																	`$${item.base_price}`
																}}
															</template>

															<!-- Slot base_discount -->
															<template
																v-slot:item.base_discount="{
																	item,
																}"
															>
																{{
																	`${item.base_discount}%`
																}}
															</template>

															<!-- Slot preferential_price -->
															<template
																v-slot:item.preferential_price="{
																	item,
																}"
															>
																{{
																	`$${item.pivot.preferential_price}`
																}}
															</template>

															<!-- Slot preferential_discount -->
															<template
																v-slot:item.preferential_discount="{
																	item,
																}"
															>
																{{
																	`${item.pivot.preferential_discount}%`
																}}
															</template>

															<!-- Slot Special -->
															<template
																v-slot:item.special="{
																	item,
																}"
															>
																<v-chip
																	v-if="
																		item.special
																	"
																	small
																	color="primary"
																>
																	Especial
																</v-chip>
															</template>

															<!-- Slot Actions -->
															<template
																v-slot:item.actions="{
																	item,
																}"
															>
																<v-btn
																	text
																	color="primary"
																	@click="
																		articlePriceListEdit(
																			item
																		)
																	"
																>
																	Editar
																</v-btn>
															</template>
														</v-data-table>
													</v-col>
												</v-row>
											</v-tab-item>
											<v-tab-item>
												<v-card flat>
													<v-card-text>
														<v-row>
															<v-col cols="12">
																<v-data-table
																	:headers="
																		headers.customers
																	"
																	:items="
																		pricelist.customers
																	"
																>
																	<!-- Slot Customer -->
																	<template
																		v-slot:item.name="{
																			item,
																		}"
																	>
																		<router-link
																			:to="{
																				name:
																					'CustomerShow',
																				params: {
																					id:
																						item.id,
																				},
																			}"
																		>
																			{{
																				item.name
																			}}
																		</router-link>
																	</template>

																	<template
																		v-slot:item.actions="{
																			item,
																		}"
																	>
																		<v-btn
																			text
																			color="primary"
																			@click="
																				customerDissociate(
																					item
																				)
																			"
																		>
																			quitar
																		</v-btn>
																	</template>
																</v-data-table>
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-tab-item>
										</v-tabs>
									</v-col>
								</v-row>
							</template>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<template v-if="pricelist">
			<!-- ArticlePriceListEdit Component -->
			<ArticlePriceListEdit></ArticlePriceListEdit>

			<!-- Synchronization -->
			<Synchronization :pricelist="pricelist" />

			<!-- CustomerAttach Component -->
			<CustomerAttach :pricelist="pricelist"></CustomerAttach>

			<!-- Article Attach -->
			<ArticleAttach :pricelist="pricelist" />

			<!-- Edición multiple -->
			<v-dialog v-model="ui.dialog" persistent max-width="600">
				<v-card class="pa-4">
					<v-card-title>
						Edición multiple
					</v-card-title>
					<v-card-subtitle>
						{{
							`Se modigicaran los ${selected.length} registros seleccionados de la lista de precios.`
						}}
					</v-card-subtitle>
					<v-card-text class="pb-0">
						<v-form
							ref="form"
							v-model="ui.valid"
							lazy-validation
							@submit.prevent="editMassive()"
						>
							<v-row>
								<v-col cols="6" class="pb-0">
									<v-text-field
										dense
										outlined
										label="Precio preferente"
										clearable
										v-model="layout.preferential_price"
										:rules="[
											v.required,
											v.min(
												'numeric',
												1,
												layout.preferential_price
											),
										]"
									></v-text-field>
								</v-col>

								<v-col cols="6" class="pb-0">
									<v-text-field
										dense
										outlined
										label="Porcentaje de descuento"
										clearable
										v-model="layout.preferential_discount"
										:rules="[
											v.required,
											v.min(
												'numeric',
												0,
												layout.preferential_discount
											),
											v.max(
												'numeric',
												100,
												layout.preferential_discount
											),
										]"
									></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions class="d-flex justify-end">
						<v-btn
							color="primary"
							text
							:disabled="ui.loading"
							@click="ui.dialog = false"
						>
							cancelar
						</v-btn>
						<v-btn
							color="primary"
							@click="editMassive()"
							:loading="ui.loading"
						>
							enviar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</template>
	</div>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { EventBus } from "@/main";

// Class
import PriceList from "@/clas/PriceList";

// Components
import TilteParallax from "@/components/TilteParallax";
import Synchronization from "@/components/PriceList/Synchronization";
import CustomerAttach from "@/components/PriceList/CustomerAssociate";
import ArticlePriceListEdit from "@/components/PriceList/ArticlePriceListEdit";
import ArticleAttach from "@/components/PriceList/ArticlePriceListCreate";

export default {
	name: "Show",

	components: {
		Synchronization,
		TilteParallax,
		CustomerAttach,
		ArticlePriceListEdit,
		ArticleAttach,
	},

	data() {
		return {
			v: V,

			pricelist: null,

			filters: {
				criterion: null,
				product_id: null,
				category_id: null,
			},

			selected: [],

			headers: {
				articles: [
					{ text: "Id", value: "id" },
					{ text: "Codigo", value: "code" },
					{ text: "Descripción", value: "description" },
					{ text: "Producto", value: "product.name" },
					{ text: "Precio base", value: "base_price" },
					{ text: "Descuento base", value: "base_discount" },
					{
						text: "Precio preferente",
						value: "preferential_price",
					},
					{
						text: "Descuento preferente(%)",
						value: "preferential_discount",
					},
					{ text: "Especial", value: "special" },
					{ text: "Acciones", value: "actions" },
				],

				customers: [
					{ text: "Id", value: "id" },
					{ text: "Folio", value: "folio" },
					{ text: "Nombre", value: "name" },
					{ text: "Acciones", value: "actions" },
				],
			},

			layout: {
				price: null,
				discount: null,
			},

			ui: {
				tab: 0,

				edit: false,

				valid: true,

				dialog: false,

				exporting: false,

				loading: true,

				forms: {
					price_list: {
						valid: true,
					},
				},
			},
		};
	},

	created() {
		this.get();

		EventBus.$on("ArticlePriceListUpdated", (items) => {
			items.forEach((item) => {
				let indexOf = this.pricelist.articles.indexOf(
					this.pricelist.articles.find(
						(article) => article.id == item.article_id
					)
				);

				this.pricelist.articles[indexOf].pivot = item;
			});
		});

		EventBus.$on("PriceListCustomerAssociated", (customer) => {
			this.pricelist.customers.push(customer);
		});

		EventBus.$on("ArticlePriceListGet", () => {
			this.get();
		});
	},

	methods: {
		async get() {
			try {
				this.ui.loading = true;

				let pl = new PriceList();

				let price_list = await pl.find(this.$route.params.id);

				this.pricelist = price_list;

				this.layout = Object.assign({}, price_list);
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		importFromCSV() {
			EventBus.$emit("MassImport");
		},

		articlePriceListEdit(articlePriceList) {
			EventBus.$emit("ArticlePriceListEdit", articlePriceList);
		},

		async exportToCSV() {
			this.ui.exporting = true;
			try {
				let data = this.pricelist.articles.map((article) => {
					return {
						id: article.id,
						code: article.code,
						description: article.description,

						base_price: article.base_price,
						base_discount: article.base_discount,

						preferential_price: article.pivot.preferential_price,
						preferential_discount:
							article.pivot.preferential_discount,

						price_list_id: article.pivot.price_list_id,

						"": "",

						article_id: article.id,
						price: article.pivot.preferential_price,
						discount: article.pivot.preferential_discount,
					};
				});

				let response = await axios.post(
					`${process.env.VUE_APP_API_SERVER}/export`,
					{
						data: data,
						name: `lprecio ${this.pricelist.name} ${moment().format(
							"ss mm HH DD MM YYYY"
						)}`,
					}
				);

				window.open(response.data.data.downloadUrl, "_blank");
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.exporting = false;
			}
		},

		customerAttach() {
			EventBus.$emit("PriceListCustomerAssociate");
		},

		articleAttach() {
			EventBus.$emit("PriceListArticleCreate");
		},

		async customerDissociate(customer) {
			if (
				confirm(
					`¿Qiere desvincular a: ${customer.name} de esta lista de precios?`
				)
			) {
				try {
					this.ui.loading = true;

					let response = await axios.delete(
						`${process.env.VUE_APP_API_SERVER}/auth/pricelist/${this.pricelist.id}/customer/${customer.id}`,
						{
							headers: {
								Authorization: `Bearer ${this.acount.token}`,
							},
						}
					);
					this.pricelist.customers.splice(
						this.pricelist.customers.indexOf(customer),
						1
					);
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				} finally {
					this.ui.loading = false;
				}
			}
		},

		editMassive() {
			if (this.$refs.form.validate()) {
				if (
					!confirm(
						"¿Quíeres actualizar los registros con lo valores establecidos?"
					)
				) {
					return 0;
				}

				this.selected.forEach((item) => {
					let index = this.pricelist.articles.indexOf(item);

					let article = this.pricelist.articles[index];

					this.pricelist.articles[index] = {
						...article,
						pivot: {
							...article.pivot,
							price: this.layout.price
								? this.layout.price
								: article.price,
							discount: this.layout.discount
								? this.layout.discount
								: article.discount,
						},
					};
				});

				this.update();
			}
		},

		async update() {
			try {
				this.ui.loading = true;

				let response = await axios.put(
					`${process.env.VUE_APP_API_SERVER}/auth/pricelist/${this.pricelist.id}/articlepricelist`,
					{
						article_price_list: this.pricelist.articles.map(
							(item) => item.pivot
						),
					},
					{
						headers: {
							Authorization: `Bearer ${this.acount.token}`,
						},
					}
				);

				this.selected = [];

				this.$refs.form.reset();

				this.ui.dialog = false;

				this.ui.loading = false;
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.get();
			}
		},

		pricelistEdit() {
			this.ui.tab = 0;

			this.ui.edit = true;
		},

		async pricelistUpdate() {
			if (confirm("¿Qiere actualizar ahora?")) {
				try {
					this.ui.loading = true;

					let pricelist = new PriceList(this.layout);

					let price_list_updated = await pricelist.update();

					await this.pricelistEditCancel();

					EventBus.$emit("Snackbar", {
						text: `Registro actualizado correctamente.`,
						type: "success",
					});
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
					throw error;
				} finally {
					this.ui.loading = false;
				}
			}
		},

		async pricelistEditCancel() {
			this.ui.edit = false;

			await this.get();
		},
	},

	computed: {
		...mapState(["acount"]),

		...mapGetters(["getCategories", "getProducts"]),

		Categories() {
			return this.getCategories.map((item) => {
				return {
					text: item.name,
					value: item.id,
				};
			});
		},

		Products() {
			let products = this.getProducts;

			// Filter Product
			if (this.filters.category_id) {
				products = products.filter(
					(item) => item.category_id == this.filters.category_id
				);
			}

			return products.map((item) => {
				return {
					text: item.name,
					value: item.id,
				};
			});
		},

		Articles() {
			let results = this.pricelist.articles;

			// Filter Category
			if (this.filters.category_id) {
				results = results.filter((item) => {
					if (item.product) {
						return (
							item.product.category_id == this.filters.category_id
						);
					}
				});
			}

			// Filter Product
			if (this.filters.product_id) {
				results = results.filter((item) => {
					if (item.product) {
						return item.product.id == this.filters.product_id;
					}
				});
			}

			return results;
		},
	},
};
</script>

<style lang="css" scoped></style>
